import { Component, Inject, ViewContainerRef } from '@angular/core';
import { AppService } from '../../../app.service';
import { DataIdName } from '../entities/global/model';
import { GETInventoryService } from '../services/inventory.service';
import { ImplementStatusModalData } from './implement-status-modal';
import { ImplementStatusModalService } from './implement-status-modal.service';
import { AddRepairerWorkshopModalComponent } from '../add-repairer-workshop-modal/add-repairer-workshop-modal.component';
import { ErrorCode, ErrorMessages } from '../entities/global/error-codes';
import { NotificationsService } from 'angular2-notifications';
import { OrdinalDateAdapter, OrdinalDateParse, ORD_DATE_FORMATS } from '../adapters/ordinal-date-adapter';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'implement-status-modal',
    templateUrl: './implement-status-modal.component.html',
    providers: [
        {
            provide: DateAdapter, useClass: OrdinalDateAdapter
        },
        {
            provide: MAT_DATE_FORMATS, useValue: ORD_DATE_FORMATS
        }
    ]

})

export class ImplementStatusModalComponent {
    jobsiteName: string;
    comment: string="";
    selectedRepairerId: number = 0;
    selectedWorkshopId: number = 0;
    statusList: DataIdName[];
    repairerList: DataIdName[];
    workshopList: DataIdName[];
    implementStatusData: ImplementStatusModalData;
    savingChanges: boolean = false;

    showRepairerAndWorkshop: boolean = false;
    showAddWorkshop: boolean = false;

    // Tooltips
    ttComment: string = "You may enter a maximum of 256 characters.";
    ttDate: string = "Click here to select a date.";
    eventDate: Date = new Date();
    maxDateForAction: Date = new Date();
    ord: OrdinalDateParse = new OrdinalDateParse();
    constructor(private _appService: AppService, public dialogRef: MatDialogRef<ImplementStatusModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any, public _moduleService: ImplementStatusModalService,
        public _inventoryService: GETInventoryService, public addRepairerWorkshopModal: MatDialog,
        public toastr: NotificationsService, vcr: ViewContainerRef) {
        
    }
    ngOnInit() {
        this.implementStatusData = new ImplementStatusModalData();
this.implementStatusData.comment="";
        if (this.data != null) {
            if (this.data.implementId != null) {
                this.implementStatusData.implementId = this.data.implementId;
            }
            if (this.data.jobsiteId != null) {
                this.implementStatusData.jobsiteId = this.data.jobsiteId;

                if (this.data.jobsiteName != null) {
                    this.jobsiteName = this.data.jobsiteName;
                }

                this.reloadRepairerListForCustomer();
            }           

            this._inventoryService.returnInventoryStatusList().subscribe(response => {
                this.statusList = response;
            }, error => { console.log(error); });
        }
    }
    reloadRepairerListForCustomer() {
        if (this.data.jobsiteId != null) {
            this._inventoryService.returnRepairerListForCustomer(this.data.jobsiteId).subscribe(response => {
                this.repairerList = response;

                if (this.selectedRepairerId != 0) {
                    this.repairerSelected(this.selectedRepairerId);
                }
            }, error => { console.log(error); });
        }
    }
    onCloseClick(): void {
        this.dialogRef.close();
    }
    saveChanges(): void {
        if (this.savingChanges) {
            return;
        }

        let validation = this.validateData();
        this.savingChanges = true;

        if (validation == ErrorCode.VALIDATION_PASSED) {
            this._moduleService.saveImplementStatus(this.implementStatusData).subscribe(response => {
                if (response == "false") {
                    this.toastr.error(ErrorMessages.ERROR_SAVING);
                    this.savingChanges = false;
                }
                else {
                    this.dialogRef.close();
                }
            }, error => { console.log(error); });
        }
        else {
            this.toastr.error(ErrorMessages.ERROR_MISSING_FIELDS);
            this.savingChanges = false;
        }
    }
    validateData(): number {
        var returnCode = ErrorCode.ERROR_MISSING_FIELDS;

        if (this.implementStatusData.jobsiteId
            && this.implementStatusData.status ) {
            if (this.implementStatusData.status < 0) {
                returnCode = ErrorCode.ERROR_MISSING_FIELDS;
            }
            // else if ((this.implementStatusData.repairerId == 0
            //     || this.implementStatusData.workshopId == 0)
            //     && this.showRepairerAndWorkshop) {
            //     returnCode = ErrorCode.ERROR_MISSING_FIELDS;
            // }
            else {
                returnCode = ErrorCode.VALIDATION_PASSED;
            }
        }

        return returnCode;
    }

    // Status
    statusSelected(statusId): void {
        this.implementStatusData.status = statusId;
        this.implementStatusData.repairerId = 0;
        this.implementStatusData.workshopId = 0;
        this.showRepairerAndWorkshop = false;

        // this._inventoryService.checkIfRepairerRequiredForStatus(statusId).subscribe(response => {
        //     if (response == true) {
        //         this.showRepairerAndWorkshop = true;
        //     }
        // }, error => { console.log(error); });
    }

    // Repairer
    repairerSelected(repairerId): void {
        this.selectedRepairerId = repairerId;
        this.implementStatusData.repairerId = repairerId;

        this._inventoryService.returnWorkshopListForRepairer(repairerId).subscribe(response => {
            this.workshopList = response;
            this.showAddWorkshop = true;

            if (this.selectedWorkshopId != 0) {
                this.workshopSelected(this.selectedWorkshopId);
            }
        }, error => { console.log(error); });
    }

    // Workshop
    workshopSelected(workshopId): void {
        this.selectedWorkshopId = workshopId;
        this.implementStatusData.workshopId = workshopId;
    }

    // Comment
    commentChanged(): void {
        this.implementStatusData.comment = this.comment;
    }

         // Date
         dateChanged(): void {
            this.implementStatusData.date = this.eventDate;
            this.implementStatusData.date = this.eventDate;
            this.ord.formatDateOrdinal((this.eventDate.toString())
                .split(' ')
                .slice(1)
                .join(' '), false);
        }

    // Add repairer and workshop
    addRepairer(): void {
        this._inventoryService.setRepairerId(0);
        let addRepairerWorkshopModalRef = this.addRepairerWorkshopModal.open(AddRepairerWorkshopModalComponent, {
            width: '550px',
            data: {
                jobsiteId: this.implementStatusData.jobsiteId,
                jobsiteName: this.jobsiteName
            }
        });
        addRepairerWorkshopModalRef.afterClosed().subscribe(() => {
            this.reloadRepairerListForCustomer();
            this.selectedRepairerId = this._inventoryService.getRepairerId();
            this.implementStatusData.repairerId = this.selectedRepairerId;
        });
    }
    addWorkshop(): void {
        this._inventoryService.setWorkshopId(0);
        let addRepairerWorkshopModalRef = this.addRepairerWorkshopModal.open(AddRepairerWorkshopModalComponent, {
            width: '550px',
            data: {
                jobsiteId: this.implementStatusData.jobsiteId,
                jobsiteName: this.jobsiteName,
                repairerId: this.implementStatusData.repairerId
            }
        });
        addRepairerWorkshopModalRef.afterClosed().subscribe(() => {
            this.reloadRepairerListForCustomer();
            this.selectedWorkshopId = this._inventoryService.getWorkshopId();
            this.implementStatusData.workshopId = this.selectedWorkshopId;
        });
    }
}
